import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import EnderecoProdutoService from 'business/cadastro/produto/enderecoProduto/enderecoProdutoService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'

export default function EnderecoProduto() {

    const [service] = useState(() => new EnderecoProdutoService())

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })
        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="setor_endp" form={form} service={service} type="text" clearString label="Setor" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="rua_endp" form={form} service={service} type="text" clearString label="Rua" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="bloco_endp" form={form} service={service} type="text" clearString label="Bloco" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="andar_endp" form={form} service={service} type="text" clearString label="Andar" />

                    </GridForm>

                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
